import { useCallback, useEffect, useRef, useState } from 'react'

const COUNTDOWN_DURATION_IN_SECONDS = 60
const SECOND = 1000

export const useCountdown = (countdownDuration = COUNTDOWN_DURATION_IN_SECONDS) => {
  const [countdown, setCountdown] = useState(countdownDuration)
  const timer = useRef<NodeJS.Timer>()

  useEffect(() => () => clearInterval(timer.current), [])

  const triggerCountdown = useCallback(() => {
    if (!timer.current) {
      setCountdown(countdownDuration)
    }
    timer.current = setInterval(() => {
      setCountdown((current) => {
        if (current === 0 && timer.current) {
          clearInterval(timer.current)
          timer.current = undefined
          return 0
        }
        return current - 1
      })
    }, SECOND)
  }, [countdownDuration])

  return { countdown, triggerCountdown }
}
